export const appVersion = import.meta.env.VITE_APP_VERSION ?? '0.2.0';
export const gitCommit = import.meta.env.VITE_GIT_COMMIT ?? 'dev';
export const repositoryUrl = 'https://github.com/baditaflorin/mastering-studio-wasm';
export const paypalUrl = 'https://www.paypal.com/paypalme/florinbadita';
